import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TvaLot } from 'src/app/models/TvaLot';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TvaLotService {

   PATH_TVA = "/programmes-lots/tva-lot/all";

constructor(private readonly http: HttpClient) { }

getAllTvasLot = (): Observable<TvaLot[]> => {
  const url = environment.host.domaine + this.PATH_TVA;
  return this.http.get<TvaLot[]>(url)
  }
}

